import { useTranslation } from 'react-i18next';
import { Button, type ButtonOwnProps } from '@mui/material';

interface ContinueProps extends ButtonOwnProps {
  onClick?(): void;
}

export const Continue: React.FC<ContinueProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Button type="submit" fullWidth variant="contained" color="primary" loadingPosition="start" {...props}>
      {t('continue')}
    </Button>
  );
};
